import clsx from 'clsx';
import type { Player, Side } from '@shared/types';
import './PlayerPanel.css';

interface PlayerPanelProps {
  player: Player;
  side: Side;
  currentSetScore: number;
  setsWon: number;
  isServing?: boolean;
  isWinner?: boolean;
}

export function PlayerPanel({
  player,
  side,
  currentSetScore,
  setsWon,
  isServing = false,
  isWinner = false,
}: PlayerPanelProps) {
  return (
    <div
      className={clsx(
        'player-panel',
        'glass-strong',
        side === 'sideA' ? 'player-panel--left' : 'player-panel--right',
        isWinner && 'player-panel--winner'
      )}
    >
      <div className="player-name">
        {player.name}
        {isServing && <span className="serving-indicator" title="Sacando">🏓</span>}
      </div>

      <div className="player-sets">
        <div className="label">Sets</div>
        <div className="value sets-value">{setsWon}</div>
      </div>

      <div className="player-score">
        <div className="label">Pontos</div>
        <div className={clsx('value score-value', isWinner && 'score-value--winner')}>
          {currentSetScore}
        </div>
      </div>

      {isWinner && <div className="winner-badge">🏆 Vencedor!</div>}
    </div>
  );
}
